import React from "react";
import { currentLoader } from "./redux/reducers/loader";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import Routings from "./Routes/Routings";
import { Toaster } from 'react-hot-toast'

function App() {
    const loading = useSelector(currentLoader);
  
    return (
        <>
          <Routings />
          <Toaster position="top-right"/>
          {loading ? (
            <div className="loader-container">
              <ClipLoader
                // color={color}
                loading={loading}
                // cssOverride={override}
                size={60}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : null}
        </>
      );
  }
  
  export default App;